import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-caption text-fun-label-and-icon" }
const _hoisted_2 = { class: "text-subtitle1" }
const _hoisted_3 = {
  key: 0,
  class: "text-body2 ellipsis"
}
const _hoisted_4 = {
  key: 1,
  class: "text-h6"
}
const _hoisted_5 = { class: "text-field-label" }
const _hoisted_6 = { class: "text-info" }

import { date } from "quasar"
import SfxCard from "src/components/card/SfxCard.vue"
import { DATE_TIME_FULL_MASK, SFX_CARD_ATTACHMENT_HEIGHT } from "src/util/constants/configurations"
import { Attachment } from "src/util/types/dataModels/attachment"
import { computed, PropType } from "vue"

//region Props and Emits


export default /*#__PURE__*/_defineComponent({
  __name: 'SfxCardAttachment',
  props: {
  attachment: {
    type: Object as PropType<Attachment>,
    required: true,
  },

  // Translated entity
  entity: {
    type: String,
  },
},
  setup(__props) {

const props = __props

//endregion

//region Variables

const placeholderImg = computed(() => getPlaceholderImg())

const createdDate = computed(() =>
  date.formatDate(props.attachment?.created_dt, DATE_TIME_FULL_MASK)
)

//endregion

//region Functions

function getPlaceholderImg() {
  switch (props.attachment?.extension) {
    case "pdf": {
      return "img/file-types/pdf.svg"
    }
    case "csv": {
      return "img/file-types/csv.svg"
    }
    case "xlsx": {
      return "img/file-types/xlsx.svg"
    }
    case "docx": {
      return "img/file-types/docx.svg"
    }
    case "txt": {
      return "img/file-types/txt.svg"
    }
    case "jpg": {
      return "img/file-types/jpg.svg"
    }
    case "jpeg": {
      return "img/file-types/jpeg.svg"
    }
    case "png": {
      return "img/file-types/png.svg"
    }
    case "dwg": {
      return "img/file-types/dwg.svg"
    }
    case "tsv": {
      return "img/file-types/tsv.svg"
    }
    default: {
      return "img/file-types/default.svg"
    }
  }
}

//endregion

return (_ctx: any,_cache: any) => {
  const _component_q_space = _resolveComponent("q-space")!
  const _directive_truncate_middle = _resolveDirective("truncate-middle")!

  return (_openBlock(), _createBlock(SfxCard, {
    "has-img": "",
    clickable: "",
    class: "q-mb-md",
    "img-src": placeholderImg.value,
    height: _unref(SFX_CARD_ATTACHMENT_HEIGHT)
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, _toDisplayString(createdDate.value), 1),
      _withDirectives(_createElementVNode("div", _hoisted_2, null, 512), [
        [_directive_truncate_middle, props.attachment?.name]
      ]),
      (props.attachment.description)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(props.attachment.description), 1))
        : _createCommentVNode("", true),
      (props.entity)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t("sfxCard.relation")), 1),
            _createVNode(_component_q_space),
            _createElementVNode("span", _hoisted_6, _toDisplayString(props.entity), 1)
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["img-src", "height"]))
}
}

})